module.exports = __webpack_public_path__ + "media/images/banner_log@2x-4964196bc1cf90e957e7dc94c24d4b11.jpg";